module.exports = __webpack_public_path__ + "img/x.3e2ca98a.png";